import React from 'react';
import * as PropTypes from 'prop-types';
import { paginationIconLinkStyles, paginationIconStyles, paginationItemStyles } from './styles/PaginationItem.css';

const PaginationItem = (props) => {
    if (props.text && !props.icon) {
        return (
            <li className={`page-item${props.active ? ' active' : ''}`} key={`page-item-${props.pageValue}`}>
                <span
                    className={`page-link${props.disabled ? ' disabled' : ''}`}
                    style={paginationItemStyles({ active: props.active })}
                    onClick={props.disabled ? null : () => props.action(props.pageValue)}
                >
                    {props.text}
                </span>
            </li>
        );
    } else {
        return (
            <li className={`page-item${props.active ? ' active' : ''}`} key={`page-item-${props.pageValue}`}>
                <span
                    className={`page-link${props.disabled ? ' disabled' : ''}`}
                    onClick={props.disabled ? null : () => props.action(props.pageValue)}
                    style={paginationIconLinkStyles}
                >
                    <i className={'material-icons'} style={paginationIconStyles}>{props.icon}</i>
                </span>
            </li>
        );
    }
};

PaginationItem.propTypes = {
    text: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    icon: PropTypes.string,
    action: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    pageValue: PropTypes.number,
    active: PropTypes.bool
};

export default PaginationItem;